export function gtmCustomEventLeadFlow(leadObj:any){
    dataLayer.push(leadObj);
}